<img src="client/assets/images/404.png" alt="">
<h1 trans>Opps! We can't find the page you're looking for.</h1>
<a routerLink="/" mat-raised-button color="accent" trans>Home</a>
